import { render, staticRenderFns } from "./myDialog2.vue?vue&type=template&id=f20cb8ae&scoped=true&"
import script from "./myDialog2.vue?vue&type=script&lang=js&"
export * from "./myDialog2.vue?vue&type=script&lang=js&"
import style0 from "./myDialog2.vue?vue&type=style&index=0&id=f20cb8ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20cb8ae",
  null
  
)

export default component.exports